import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Progress } from 'reactstrap';
import { useIntl } from 'react-intl';

const BulkVersioningFileListItem = ({ uploader, file, fileExists }) => {
  const intl = useIntl();

  const [uploaded, setUploaded] = useState(0);
  const [total, setTotal] = useState(0);

  const onProgress = useCallback((fileId, name, bytesUploaded, totalSize) => {
    if (fileId === file.id) {
      setUploaded(bytesUploaded);
      setTotal(totalSize);
    }
  }, [file]);

  useEffect(() => {
    uploader.on('progress', onProgress);

    return () => {
      uploader.off('progress', onProgress);
    };
  }, [uploader, onProgress]);

  const progress = (uploaded / total) * 100 || 0;

  return (
    <tr className={classnames(fileExists ? 'new-version' : 'new-file')}>
      <td>{file.hdcFullPath}</td>
      <td className="center bulk-versioning-file-status">
        {fileExists ? (
          <span>
            {intl.formatMessage({ defaultMessage: 'new version' })}
          </span>
        ) : (
          <span>
            {intl.formatMessage({ defaultMessage: 'new file' })}
          </span>
        )}
        {progress > 0 && (
          <Progress value={progress} />
        )}
      </td>
    </tr>
  );
};

BulkVersioningFileListItem.propTypes = {
  uploader: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  fileExists: PropTypes.bool.isRequired,
};

export default BulkVersioningFileListItem;
